
















import { Component, Vue, Prop } from 'vue-property-decorator';
import Header from '@/components/Header.vue';
import { SurveyMultipleSelectOptions } from '@/models/survey-elements/multiple-select-options';
import { SurveySelectOptionPayload } from '@/models/survey-elements/select-option-payload';
import { EventBus } from '@/event-bus';
import { SurveyMultipleSelectElement } from '@/models/survey-elements/multiple-select-element';
import { WIDGET_EVENTS } from '@/const/widget-events';
import MultipleSelectItem from '@/components/MultipleSelectItem.vue';
import { ANALYTICS_EVENTS } from '@/const/analytics-events';

@Component({
  name: 'multi-select-widget',
  components: {
    Header,
    MultipleSelectItem,
  },
})
export default class MultipleSelectElement extends Vue {
  @Prop({ type: String }) externalApiIdentifier!: string | null;
  @Prop({ type: Array }) value!: SurveyMultipleSelectOptions[];
  @Prop({ type: Array, required: true })
  options!: SurveyMultipleSelectOptions[];
  @Prop({ type: String }) title?: string;
  @Prop({ type: Number }) maxAllowedOptionsNumber?: number | null;
  @Prop({ type: Object }) field?: SurveyMultipleSelectElement;

  private localValue: number[] = [];
  private latestOption: SurveySelectOptionPayload | null = null;
  private localOptions: SurveyMultipleSelectOptions[] = this.options;

  private created() {
    this.localValue = this.value ? this.value.map(item => item.value) : [];
    this.handleExternalApiIdentifier();
  }

  private handleExternalApiIdentifier() {
    if (!this.externalApiIdentifier) return;

    let externalApiIdentifier = (
      this.$route.query[this.externalApiIdentifier] as string | undefined
    )?.split(',');

    if (!externalApiIdentifier) return;
    if (this.maxAllowedOptionsNumber) {
      externalApiIdentifier = externalApiIdentifier.slice(
        0,
        this.maxAllowedOptionsNumber
      );
    }
    const preselectedOption = this.options
      .filter(option => externalApiIdentifier?.includes(`${option.value}`))
      .map(item => item.value);

    if (!preselectedOption) return;
    this.localValue = preselectedOption;

    this.emitData();
  }

  private changeValue(customOption: { value: number; customValue: string }) {
    this.localOptions.find(
      option => option.value === customOption.value
    )!.customValue = customOption.customValue;
    this.emitData();
  }

  private changeEvent(option: SurveySelectOptionPayload) {
    this.latestOption = option;
    this.updateLocalValue(option.value);
    this.ensureMaxAllowedOptions();
    this.localOptions.find(item => item.value === option.value)!.customValue =
      null;
    this.emitData();
  }

  private updateLocalValue(value: number) {
    const index = this.localValue.indexOf(value);

    if (index > -1) {
      this.localValue.splice(index, 1);
    } else if (
      !this.maxAllowedOptionsNumber ||
      this.localValue.length < this.maxAllowedOptionsNumber
    ) {
      this.localValue.push(value);
    }
  }

  private ensureMaxAllowedOptions() {
    if (this.maxAllowedOptionsNumber === 1 && this.localValue.length > 1) {
      this.localValue.shift();
    }
  }

  private emitData() {
    const selectedOptions = this.constructSelectedOptions();
    const emitValue = this.getEmitValue(selectedOptions);

    this.emitChangeEvent(emitValue);
  }

  private constructSelectedOptions() {
    return this.localOptions.reduce(
      (
        acc: {
          value: number;
          label: string | null;
          allowCustomValue: boolean;
        }[],
        { value, label, customValue, allowCustomValue }
      ) => {
        if (this.localValue.some((item: number) => item == value)) {
          let localLabel;

          if (allowCustomValue) {
            localLabel = customValue ? customValue : null;
          } else {
            localLabel = label;
          }

          acc.push({ value, label: localLabel, allowCustomValue });
        }
        return acc;
      },
      []
    );
  }

  private getEmitValue(
    selectedOptions: { value: number; label: string | null }[]
  ) {
    return selectedOptions.length &&
      !selectedOptions.some(item => item.label === null)
      ? selectedOptions
      : null;
  }

  private emitChangeEvent(
    emitValue: { value: number; label: string | null }[] | null
  ) {
    EventBus.$emit(WIDGET_EVENTS.CHANGE, {
      field: this.field,
      value: emitValue,
    });
  }
}
